import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildTrainingsDataTableFilter,
  useTrainingsDataTable,
} from 'generated/resources/datatable.graphql'
import { CompetencyFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const competenciesFilter = (
  source: ReturnType<typeof useTrainingsDataTable>,
  identifier: string,
  competencies: CompetencyFragment[] | undefined
) => {
  const options = competencies
    ? competencies.map((competency) => {
        return {
          label: competency.name,
          value: Number(competency.id),
          component: (
            <Box flexDirection="row" alignItems="center" gap="s8">
              <Text.Normal weight="medium">{competency.name}</Text.Normal>
            </Box>
          ),
        }
      })
    : []

  return buildTrainingsDataTableFilter(source, {
    type: FilterType.Integer,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: identifier,
    path: 'competencyId',
    title: i18n.t('trainings.trainings_table.competencies'),
    onUpdateValue: () => {
      track(trackingEvents.training.trainingsFilters.competenciesFilter)
    },
  })
}
